<template>
    <div class='Box'>
      <div class="div_buttom">
        <el-button size="medium" type="primary" icon="el-icon-back" @click="goBack">返回</el-button>
      </div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ nid + ' - ' + nname }}</span>
        </div>
        <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
          <el-row :gutter="35">
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="ID">
                <el-input v-model="queryParams.id" @change="search" placeholder="请输入ID"
                          clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="章节序号">
                <el-input v-model="queryParams.index" @change="search" placeholder="请输入章节序号" clearable></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="章节名称">
                <el-input v-model="queryParams.name" @change="search" placeholder="请输入章节名称"
                          clearable></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="卷ID">
                <el-input v-model="queryParams.roll_id" @change="search" placeholder="请输入卷ID" clearable></el-input>
              </el-form-item>
            </el-col>
  
            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="卷名称">
                <el-input v-model="queryParams.roll_name" @change="search" placeholder="请输入卷名称" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <div class="btn_left">
                <el-button type="primary" size="medium" @click="search">查询</el-button>
                <el-button @click="addNoNe" size="medium">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div class="div_buttom">
          <el-button size="medium" @click="addNoNe">刷新列表</el-button>
          <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
          <el-button size="medium" type="primary" plain icon="el-icon-plus" @click="handleBatch">批量添加</el-button>
        </div>
        <MyTable
          ref="myTableRef"
          :table-data="tableData"
          :columns="columns"
          :loading="loading"
  
          :total="total"
          :page-no="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @pagination-change="paginationChange"
        >
          <template #content="{ scope }"> 
            <div class="page_link" @click="handleView(scope.row)">查看内容</div>
          </template>
          <!-- 付费锚点 -->
        <template #anchor_text="{value}">
          <el-tooltip placement="bottom">
            <div slot="content" class="maxw110" v-html="value"></div>
            <span class="description-span">{{ value }}</span>
          </el-tooltip>
        </template>
          <template #operation>
            <el-table-column fixed="right" label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="medium" class="mr10" @click="handleEdit(scope.row)">编辑</el-button>
                <el-popconfirm
                  confirm-button-text='确定'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定要删除吗？"
                  @confirm="handleDel(scope.row.id)"
                >
                  <el-button slot="reference" type="text" class="PUB_BTN_RED">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </template>
        </MyTable>
        <edit 
          v-if="dialogVisible" 
          :nid="nid"
          :salesType="salesType"
          :payChapter="payChapter"
          :currentTotal="total"
          :editID="editID"
          :dialogVisible="dialogVisible" 
          @NoneDlog="NoneDlog" 
          @AddOk="AddOk"
        >
        </edit>

        <batchEdit 
          v-if="batchVisible" 
          :nid="nid"
          :dialogVisible="batchVisible" 
          @NoneDlog="NoneDlogBatch" 
          @AddOk="AddOkBatch"
        >
        </batchEdit>
      </el-card>

      <el-dialog
        :title="activeChapter.name"
        :visible.sync="contentVisible"
        width="60%"
        :before-close="()=>{this.contentVisible = false}">
        <el-input style="color:#333;width: 100%;" v-model="activeChapter.content" type="textarea" disabled autosize></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="contentVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import {KsNovalManagement} from "@/api/ksNovalManagement";
  import {processErrors} from "@/utils/errorHandler";
  const api = KsNovalManagement();
  export default {
    components: {
      Edit:()=>import('./component/chapterEdit.vue'),
      BatchEdit:()=>import('./component/batchChapter.vue')
    },
    data() {
      return {
        columns:[
          {
            label: 'ID',
            prop: 'id',
            width: '80',
          },
          {
            label: '章节序号',
            prop: 'index',
            slotKey: 'index',
            width: '100',
          },
          {
            label: '章节名称',
            prop: 'name',
          },
          {
            label: '卷ID',
            prop: 'roll_id',
          },
          {
            label: '卷名称',
            prop: 'roll_name',
          },
          {
            label: '付费锚点',
            prop: 'anchor_text',
            slotKey: 'anchor_text',
          },
          {
            label: '章节内容',
            prop: 'content',
            slotKey: 'content',
          },
          {
            label: '章节字数',
            prop: 'word_num',
          },
        ],
        queryParams: {
          pageNo: 1,
          pageSize: 10,
          name: "",
          id:'',
          index:'',
          roll_id: '',
          roll_name: '',
        },
        appidList: [],
        page: {
          pageNo: 1,
          pageSize: 999,
        },
  
        tableData: [],
        editID: "",
        // 总条数
        total: 0,
        dialogVisible: false,
        loading: false,

        nid:'', // 小说id
        nname:'', // 小说名
        salesType:'',//小说收费类型
        payChapter: '',//收费章节序号
        activeChapter:{},
        contentVisible: false,

        batchVisible: false,
      };
    },
    created() {
      let query = this.$route.query
      if(query.nid){
        this.nid = query.nid
        this.nname = query.name
        this.salesType = query.salesType
        this.payChapter = Number(query.freeChapterTotal) + 1
        
      }
      this.getList()
    },
    methods: {
  
      getList(type) {
        this.loading = true
        if (type != 'changePage') {
          this.queryParams.pageNo = 1
        }
        let query = {
          ...this.queryParams,
          novel_id: this.nid
        }
        
        api.ApiChapterList(query).then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data
            this.total = res.data.totalCount
          } else {
            processErrors(res);
          }
          this.loading = false
        })
      },
      paginationChange({pageNo, pageSize}){
        this.queryParams.pageNo = pageNo
        this.queryParams.pageSize = pageSize
        this.getList('changePage')
      },
      search() {
        this.getList()
      },
      goBack() {
        this.$router.push({
          path: '/ksNovalManagement/novalManagement',
          query:{
            isback: 1,
          }
        })
      },
      changeUse(item){
        let statusText = item.is_use == 1 ? '关闭' : '启用'
        this.$alert( `确定要${statusText}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.ApiPlatformUpdateStatus({
            id: item.id,
            is_use: item.is_use == 1 ? 0 : 1
          }).then(result => {
            if (result.code == 0) {
              this.$message({
                message: statusText + '成功',
                type: 'success'
              });
              this.getList('changePage')
            } else {
              this.$message({
                message: statusText + '失败:' + result.msg,
                type: 'error'
              });
            }
          });
        })
      },
      handleDel(id){
        api.ApiPlatformDel({id}).then(res=>{
          if (res.code == 0) { 
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList('changePage')
          }
        })
      },
      addNoNe() {
        this.queryParams = {
          pageNo: 1,
          pageSize: 10,
          name: "",
          id:'',
          index:'',
          roll_id: '',
          roll_name: '',
        }
        this.getList()
      },
      addList() {
        this.editID = ""
        this.dialogVisible = true
      },
      NoneDlog() {
        this.dialogVisible = false
      },
      AddOk() {
        this.editID = ""
        this.dialogVisible = false
        this.getList()
      },
      handleEdit(row) {
        this.editID = row.id
        this.dialogVisible = true
      },
      handleView(item){
        this.activeChapter = item
        this.contentVisible = true
      },

      // 批量添加
      handleBatch(){
        this.batchVisible = true
      },
      NoneDlogBatch() {
        this.batchVisible = false
      },
      AddOkBatch() {
        this.batchVisible = false
        this.getList()
      },
    },
  }
  </script>
  <style lang='scss' scoped>
  .Box {
    & ::v-deep el-card__body {
  
      padding: 0 !important;
  
    }
  }
  
  .el-card__body {
    padding: 0px !important;
  }
  
  .btn_left {
    margin-left: 100px;
  }
  
  .div_buttom {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
  }
  
  ::v-deep .el-radio input[aria-hidden="true"] {
    display: none !important;
  }

  .page_link{
    // 表格中的点击跳转链接样式
    color: var(--prev-color-primary) !important;
    cursor: pointer;
    &:hover{
        opacity: 0.8 !important;
    }
    &:active{
        opacity: 0.6 !important;
    }
}

::v-deep.el-textarea.is-disabled .el-textarea__inner{
  color:#333 !important;
    cursor: context-menu;
}
.maxw110{
  max-width: 110px;
}

.description-span {
  display: -webkit-box;
  /* 对于 Webkit 浏览器的兼容性 */
  -webkit-line-clamp: 3;
  /* 显示的行数 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  overflow: hidden;
  text-overflow: ellipsis;
  //white-space: nowrap;
}
  </style>